export const fixAmount = (a?: string | number, precision = 2): number =>
  a ? parseFloat(parseFloat(a.toString()).toFixed(precision)) : 0;

export function toPrecision(n: number, precision = 2): number {
  return parseFloat(n.toFixed(precision));
}

export function parseInteger(v: number | string) {
  return parseInt(v.toString(), 10);
}

export function parseNumber(v: number | string) {
  return parseFloat(v.toString());
}

export function total<T>(array: T[] | undefined, func: (data: T) => number): number {
  return array?.reduce((total, curr) => total + func(curr), 0) ?? 0;
}
